query SearchCategories(
    $term: String!
) {
    searchCategories(
        term: $term
    ) {
        id

        name(language: "en") {
            text
        }
    }
}
